export const ID_FILTER_REG = /\.(mjs|js|ts|vue|jsx|tsx)(\?.*|)$/;
export const NODE_MODULES_FLAG = 'node_modules';
export const CACHE_DIR = '.vite-plugin-externals';
